"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _DevTools = _interopRequireDefault(require("../utils/DevTools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Loading = function Loading() {
  return /*#__PURE__*/_react["default"].createElement("div", null, "LOADING...");
};

var Nope = function Nope() {
  return /*#__PURE__*/_react["default"].createElement("div", null, "Nope!");
};

var Controller = /*#__PURE__*/function (_React$Component) {
  _inherits(Controller, _React$Component);

  var _super = _createSuper(Controller);

  function Controller(props) {
    var _this;

    _classCallCheck(this, Controller);

    _this = _super.call(this, props);

    _this.onData = function () {
      _this.setState(_this.getData(), function () {
        // If an autorun method returns a truthy value, remove it from the list.
        _this._autoruns = _lodash["default"].pickBy(_this._autoruns, function (method) {
          return !method();
        });
      });
    };

    _this.runSubscribe = function () {
      _DevTools["default"].runInDevMode(function () {
        if (_this.subscribers) {
          _lodash["default"].each(_this.subscribers(), function (subscriber) {
            if (!(subscriber.subscribe && subscriber.unsubscribe)) {
              console.error("Subscriber does not conform to the interface. Subscriber:", subscriber);
            }
          });
        }
      });

      if (_this.subscribers) {
        _lodash["default"].each(_this.subscribers(), function (subscriber) {
          return subscriber.subscribe(_this.onData);
        });
      }

      if (_this.subscribe) {
        _this.subscribe(_this.onData);
      }

      _this.onData();
    };

    _this.runUnsubscribe = function () {
      if (_this.subscribers) {
        _lodash["default"].each(_this.subscribers(), function (subscriber) {
          return subscriber.unsubscribe(_this.onData);
        });
      }

      if (_this.unsubscribe) {
        _this.unsubscribe(_this.onData);
      }
    };

    _this.componentWillMount = function () {
      // Note (Hubert, 2019B):
      //   This method should be called right after the constructor is done,
      //   as the data is required for the constructor to work properly,
      //   but the notation doesn't work in the controller itself.
      //   This seems to be a good place.
      _this.precompileHandlers();

      if (_this.controllerWillMount) {
        _this.controllerWillMount();
      }

      if (_this.fetch) {
        _this.fetch();
      }

      _this.runSubscribe();
    };

    _this.componentWillUnmount = function () {
      _this.runUnsubscribe();

      if (_this.unfetch) {
        _this.unfetch();
      }

      if (_this.controllerWillUnmount) {
        _this.controllerWillUnmount();
      }
    };

    _this.areParamsUnchanged = function (newProps, oldProps) {
      var _newProps$location, _oldProps$location, _newProps$match, _oldProps$match;

      return ((_newProps$location = newProps.location) === null || _newProps$location === void 0 ? void 0 : _newProps$location.pathname) === ((_oldProps$location = oldProps.location) === null || _oldProps$location === void 0 ? void 0 : _oldProps$location.pathname) && _lodash["default"].isEqual((_newProps$match = newProps.match) === null || _newProps$match === void 0 ? void 0 : _newProps$match.params, (_oldProps$match = oldProps.match) === null || _oldProps$match === void 0 ? void 0 : _oldProps$match.params) && newProps.hive === oldProps.hive;
    };

    _this.componentWillReceiveProps = function (newProps) {
      if (_this.areParamsUnchanged(newProps, _this.props)) {
        return;
      }

      _this.setState({});

      _this.runUnsubscribe();

      if (_this.unfetch) {
        _this.unfetch();
      }

      if (_this.controllerWillReceiveProps) {
        _this.controllerWillReceiveProps(newProps);
      }

      _lodash["default"].defer(function () {
        _this.runSubscribe();

        if (_this.fetch) {
          _this.fetch();
        }
      });
    };

    _this.precompileHandlers = function () {
      if (_this._handlers) {
        return;
      }

      _this._handlers = _lodash["default"].fromPairs(_lodash["default"].map(_this.constructor._handlers, function (key) {
        return [key, _this[key]];
      }));
    };

    _this.getChildProps = function () {
      return _lodash["default"].assign({}, _this._handlers, _this.state, {
        routes: _this.props.routes,
        children: _this.props.children,
        controllerProps: _this.props
      });
    };

    _this.isFound = function () {
      return true;
    };

    _this.autorun = function (key, method) {
      _this._autoruns[key] = method;
    };

    _this.clearAutorun = function (key) {
      if (_this._autoruns[key]) {
        delete _this._autoruns[key];
      }
    };

    _this.mainComponent = Nope;
    _this.loadingComponent = Loading;
    _this.notFoundComponent = Nope;

    _this.fetch = function () {};

    _this.subscribe = function (onData) {};

    _this.unsubscribe = function (onData) {};

    _this.getData = function () {
      return {};
    };

    _this.isReady = function () {
      return true;
    };

    _this.state = {};
    _this._autoruns = {};
    return _this;
  }

  _createClass(Controller, [{
    key: "routeProps",
    get: function get() {
      var _this$props$match;

      return ((_this$props$match = this.props.match) === null || _this$props$match === void 0 ? void 0 : _this$props$match.params) || {};
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.isReady()) {
        return _react["default"].createElement(this.loadingComponent, this.getChildProps());
      }

      if (!this.isFound()) {
        return _react["default"].createElement(this.notFoundComponent, this.getChildProps());
      }

      if (this.renderErrors) {
        var result = this.renderErrors();

        if (result) {
          return result;
        }
      }

      if (this.title) {
        document.title = this.title();
      }

      return _react["default"].createElement(this.mainComponent, this.getChildProps());
    }
  }]);

  return Controller;
}(_react["default"].Component);

Controller.setGlobalNopeComponent = function (component) {
  return Nope = component;
};

Controller.setGlobalLoadingComponent = function (component) {
  return Loading = component;
};

;

_DevTools["default"].expose({
  Controller: Controller
});

var _default = Controller;
exports["default"] = _default;